
import { defineComponent, PropType } from "@vue/runtime-core";
export default defineComponent({
	name: "SlotSkeleton",
	props: {},
	methods: {},
	computed: {},
});
